export const env: ImportMetaEnv = {
  MODE: import.meta.env.MODE,
  VITE_DD_RUM_APPLICATION_ID: import.meta.env.VITE_DD_RUM_APPLICATION_ID,
  VITE_DD_RUM_CLIENT_TOKEN: import.meta.env.VITE_DD_RUM_CLIENT_TOKEN,
  VITE_ENABLE_VUE_QUERY_DEV_TOOLS: import.meta.env.VITE_ENABLE_VUE_QUERY_DEV_TOOLS,
  VITE_REPLENISHMENT_SUGGESTIONS: import.meta.env.VITE_REPLENISHMENT_SUGGESTIONS,
  VITE_REPLENISHMENT_DRAFTS: import.meta.env.VITE_REPLENISHMENT_DRAFTS,
  VITE_RELEASE_VERSION: import.meta.env.VITE_RELEASE_VERSION,
  VITE_KNOCK_API_KEY: import.meta.env.VITE_KNOCK_API_KEY,
  VITE_KNOCK_FEED_ID: import.meta.env.VITE_KNOCK_FEED_ID,
  VITE_PLAID_ENV: import.meta.env.VITE_PLAID_ENV,
  VITE_DATADOG_ENABLED: import.meta.env.VITE_DATADOG_ENABLED,
  VITE_ENABLE_OMS_DEMO: import.meta.env.VITE_ENABLE_OMS_DEMO,
  VITE_ENABLE_OMS_GUEST_CHECKOUT: import.meta.env.VITE_ENABLE_OMS_GUEST_CHECKOUT,
  VITE_SEGMENT_WRITE_KEY: import.meta.env.VITE_SEGMENT_WRITE_KEY,
  VITE_SEGMENT_CDN_PROXY_HOST: import.meta.env.VITE_SEGMENT_CDN_PROXY_HOST,
  VITE_SEGMENT_API_PROXY_HOST: import.meta.env.VITE_SEGMENT_API_PROXY_HOST,
  VITE_DELIGHTED_ENABLED: import.meta.env.VITE_DELIGHTED_ENABLED,
  VITE_MP_API_URL: import.meta.env.VITE_MP_API_URL,
  VITE_MP_API_HOST: import.meta.env.VITE_MP_API_HOST,
  VITE_GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  VITE_ZENDESK_ENABLED: import.meta.env.VITE_ZENDESK_ENABLED,
  VITE_OMS_USERNAME: import.meta.env.VITE_OMS_USERNAME,
  VITE_OMS_PASSWORD: import.meta.env.VITE_OMS_PASSWORD,
  VITE_OMS_SERVICE_API_URL: import.meta.env.VITE_OMS_SERVICE_API_URL,
  VITE_SSR_IFRAME_QUERY_KEY: import.meta.env.VITE_SSR_IFRAME_QUERY_KEY,
  VITE_SSR_IFRAME_QUERY_VALUE: import.meta.env.VITE_SSR_IFRAME_QUERY_VALUE,
  VITE_I18N_LOCALE: import.meta.env.VITE_I18N_LOCALE,
  VITE_TEST_I18N: import.meta.env.VITE_TEST_I18N,
  VITE_SENTRY_ENABLED: import.meta.env.VITE_SENTRY_ENABLED,
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  VITE_SEGMENT_ENABLED: import.meta.env.VITE_SEGMENT_ENABLED,
  VITE_DATADOG_RUM_ENABLED: import.meta.env.VITE_DATADOG_RUM_ENABLED,
  VITE_DEV_PORT: import.meta.env.VITE_DEV_PORT,
  BASE_URL: import.meta.env.BASE_URL,
  DEV: import.meta.env.DEV,
  PROD: import.meta.env.PROD,
  SSR: import.meta.env.SSR,
};

export default env;
